module.exports = __webpack_public_path__ + "img/ctrl-pauli-y-stub-0.27526dbd.svg";